import { getAdminErrorMessage } from '../adminErrorModel'
import { StatementRepairResult } from './statementRepairApi'

export const getRepairQueuedMessage = ({ statementCount, invoiceCount }: StatementRepairResult): string => {
  if (statementCount === 0) {
    return 'No statements with a pending or completed payment were found; nothing to repair.'
  }
  const invoices = invoiceCount === 1 ? '1 invoice' : `${invoiceCount} invoices`
  const statements = statementCount === 1 ? '1 statement' : `${statementCount} statements`
  return `Queued summary rebuilds for ${invoices} across ${statements}.`
}

export const getRepairErrorMessage = (error: unknown): string => {
  return getAdminErrorMessage(error, 'Failed to queue the statement repair. Please try again.')
}
